// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"b4a369e2","541":"2210613d","651":"739efe7a"}[chunkId] + ".chunk.js";
};